export enum REPORT_FREQUENCY {
  ONCE = 'Once',
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly'
}

export enum VirtualColId {
  QuickFilterVirtualColumnId = 'searchExpression'
}

export enum NotificationStatus {
  ERROR = 'error',
  WARNING = 'warning'
}
